import { Person } from 'libs/api/people'

export function getName(person: Pick<Person, 'first_name' | 'last_name'>) {
  return `${person.first_name} ${person.last_name}`
}
